angular = require('angular')
pkg = angular
  .module 'common.selector', []
  .directive "selector", require('./selector')
  .directive "selectable", require('./selectable')
  .directive "selectall", require('./selectall')
  .service "selector", require('./modal')
  
module.exports = pkg.name


// WEBPACK FOOTER //
// ./src/common/selector/index.coffee